<div pRipple class="clickable-card" [ngClass]="{ dark: globalService.theme() === 'dark' }">
  <ng-content></ng-content>
</div>
